module.exports = __webpack_public_path__ + "static/media/community.e2603aae.png";